import { configuredUrl } from "@greg-chick/shared";

/**
 * **운영자 화면으로 가는 문** — 설정 시트 맨 아래에 놓는다.
 *
 * ## 왜 아이 화면에 두나
 * 관리자는 **다른 주소**(`admin.woorinabiglobal.com`)에 있어서, 운영자가 그 주소를 외우거나
 * 즐겨찾기를 해 둬야 들어갈 수 있었다. 행사장에서 폰으로 급히 고칠 일이 생기면 그게 막힌다.
 * 그래서 설정 맨 아래에 눈에 띄지 않는 줄 하나로 둔다.
 *
 * ## 눌러도 아무나 못 들어간다
 * 관리자는 **토큰을 넣어야** 열린다(엣지가 검사한다). 이 버튼은 주소를 여는 것뿐이라
 * 권한이 생기지 않는다 — 아이가 눌러도 로그인 화면만 본다.
 *
 * ## 🔴 주소가 없으면 **버튼을 아예 안 그린다**
 * 운영 빌드에 `VITE_ADMIN_ORIGIN` 을 안 넣으면 기본값이 `http://localhost:5174` 인데,
 * 그건 **아이 폰에서는 열리지 않는 주소**다. 그런 버튼을 보여 주면 "눌렀는데 안 되네"가 된다.
 * `configuredUrl` 이 자리표시자·로컬주소를 걸러 준다(로컬 개발 중에는 로컬 주소가 정상이라 통과).
 */
export function adminConsoleUrl(
  configured: string | undefined = import.meta.env.VITE_ADMIN_ORIGIN,
  isDev: boolean = import.meta.env.DEV,
): string | undefined {
  // dev 에서는 관리자가 늘 :5174 에 뜬다(pnpm dev:all) — 설정 없이도 바로 갈 수 있게
  const raw = configured?.trim() || (isDev ? "http://localhost:5174" : "");
  return configuredUrl(raw, isDev);
}
